export const REGEX_DATE_YYYY_MM_DD = /^\d{4}-\d{2}-\d{2}$/;
export const REGEX_BOT = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4}$/;
export const REGEX_DATE_STRING = /^[\p{L}ñÑ]+,\s(\d{2}\/\d{2}\/\d{4})$/u;
